import { gql } from '@apollo/client';

export const RETRIEVE_ORDER_DETAILS = gql`
  query v2FindOrders($id: String!) {
    v2FindOrders(where: { id: { equals: $id } }) {
      id
      organizationId
      orderNumber
      createdAt
      dueDate
      rush
      status
      deviceColorSwapApproved
      flexibleLeadTimeApproved
      finalDestination
      shippingType {
        name
      }
      orderType {
        id
        name
        toRecipient
        toDropRecipient
      }
      recipient {
        id
        firstName
        lastName
        email
        address {
          streetAddress1
          streetAddress2
          city
          state
          principalRegion
          zipCode
          country
        }
      }
      orderItems {
        id
        inboundOrderItemId
        serialNumber
        orderItemNumber
        mdmPin
        mdmPins
        activationKeys
        recoveryCodes
        assetId
        asset {
          id
          assetNumber
        }
        productVariant {
          product {
            name
          }
        }
        shipment {
          status
          substatus
          substatusDescription
          shipmentCarrierId
          trackings {
            id
            trackingNumber
            trackingLink
            expectedDeliveryDate
          }
        }
        shipmentItems {
          shipmentId
          shipment {
            trackings {
              id
              trackingNumber
              trackingLink
              expectedDeliveryDate
            }
            shipmentCarrierId
            status
            substatus
            substatusDescription
          }
          createdAt
        }
      }
    }
  }
`;
